import { Component, OnInit, OnDestroy, HostListener } from "@angular/core";
import * as loginStrings from "../stringFiles/newLogin.json";
import { NewLoginWithDomainVerificationServices } from "./new-login-with-domain-verification.service";
import { StaffLoginService } from "../staff/services/staff-login.service";
import { firstValueFrom } from "rxjs";
import { Router } from "@angular/router";
import { commonFunctionService } from "../utils/commonFunctions";
import { NgModel } from '@angular/forms';
import { ViewChild } from '@angular/core';
import { TranslateService, LangChangeEvent } from "@ngx-translate/core";
import { STAFF_DEFAULT_SCREEN } from "../staff/constant/staff-default-screen.config";
import { BrandService } from "../brand/brand.service";

declare var $: any;
declare var customToastr: any;
@Component({
  selector: "app-new-login-with-domain-verification",
  templateUrl: "./new-login-with-domain-verification.component.html",
  styleUrl: "./new-login-with-domain-verification.component.css",
  providers: [NewLoginWithDomainVerificationServices, StaffLoginService],
})
export class NewLoginWithDomainVerificationComponent implements OnInit, OnDestroy {
  loginStrings: any = loginStrings;
  messages: any = [];
  currentIndex: number;
  userEmail: string;
  emailAddressLength: number = 0;
  isEmailAddressValid: boolean = false;
  loginDebounceTimer: any;
  passwordType : any = 'password';
  subDomain: string;
  loader: boolean = false;
  password: string;
  passwordLength: number = 0;
  errorMessage = {
    userEmail: "",
    password: "",
  };
  loginSchoolLogo: string;
  otpAttemptLeftCount: number;
  showPasswordInput: boolean = true;
  notVerifiedSchoolDetails: boolean;
  otpVerificationPage: boolean = false;
  otp: string[] = ["", "", "", ""];
  otpInputsFilled: boolean = false;
  getAuthToken: any;
  countdown: number;
  otpTime: number = 30;
  isForgotPassword: boolean = false;
  isResetPassword: boolean = false;
  confirmNewPassword: string;
  // Staff's forgot-password OTP is 6 digits; admin's is 4 — array length
  // tracks isStaffLogin so the same UI/state works for both.
  otpForForgotPassword: string[] = ["", "", "", ""];
  isGoBack: boolean = false
  // Set once verifyOtpForForgotPassword succeeds for a staff user - proves
  // the OTP was already checked, so resetPasswordForStaff (a separate call,
  // unlike the admin flow's single OTP+password resetPassword API) doesn't
  // need the OTP itself again.
  private staffForgotPasswordToken: string | null = null;
  isStaffLogin : boolean = false;
  loginMode = 'WEB_ADMIN';
  isFranchise = 0;
  fkFranchiseId = null;
  langChangeSub: any;
  brand = this.brandService.brand;

  @ViewChild('passwordInput') passwordInput!: NgModel;
  constructor(
    private newLoginWithDomainVerificationServices: NewLoginWithDomainVerificationServices,
    private staffLoginService: StaffLoginService,
    private router: Router,
    private commonFunction: commonFunctionService, private translate: TranslateService,
    private brandService: BrandService
  ) {
    this.generateRandomIndex();
    const domainUrl = window.location.host;
    const domainParts = domainUrl.split(".");
    const subDomainDetails = domainParts[0];
    this.subDomain = subDomainDetails;
    this.notVerifiedSchoolDetails = false;
    this.verifySchoolDomainDetails(subDomainDetails);
  }

  ngOnInit(): void {
    this.initScript();
    this.checkSession();
    this.loadQuotes();
    this.checkCookiesLang();
    this.langChangeSub = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.loadQuotes();
    });
  }

  // hostName.split(".")[1] only correctly identifies "localhost" when the
  // page is loaded via a subdomain (e.g. myschool.localhost:4200) — on bare
  // localhost:4200 (no subdomain) it evaluates to undefined, silently
  // falling through to the production cookie-writing branch (domain=
  // bluewings.in), which the browser rejects when served from localhost.
  // This checks both the subdomain and bare-host cases.
  private isLocalHost(hostName: string): boolean {
    const parts = hostName.split(".");
    return parts[1] === this.loginStrings.localhost || parts[0] === this.loginStrings.localhost;
  }

  // Where to send the user back to the login screen on a real (non-local)
  // domain — e.g. "app.maples.synclovis.academy/#/login". Built from the
  // active brand's domainSuffix instead of loginStrings.prodHostLoginUrl,
  // which hardcoded "app.bluewings.in" and always redirected there
  // regardless of which brand's domain the user was actually on.
  private prodHostLoginUrl(): string {
    const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
    return "//app." + domainSuffix + "/#/login";
  }

  checkCookiesLang(){
    const lang:any = this.getCookieValue('lang');
    if(lang==null) return;
    if(lang){
      localStorage.setItem('lang', lang);
    }
    else{
      localStorage.setItem('lang', 'en');
    }
    this.changeLanguage(lang ? lang : 'en');
  }

  changeLanguage(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('lang', lang);
  }

      // fetch cookie value from cookie data
    getCookieValue(cookieName) {
        const cookies = document.cookie.split("; ");
        for (let cookie of cookies) {
            const [key, value] = cookie.split("=");
            if (key === cookieName) {
                return decodeURIComponent(value);
            }
        }
        return null;
    }

  loadQuotes() {
    this.translate.get('LOGIN_QUOTES').subscribe((quotes: any[]) => {
      this.messages = quotes;
    });
  }

  ngOnDestroy(): void {
    this.stopQrCodeTimer();
    this.stopQrCodePolling();
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }

  initScript() {
    $(".after").empty();
    $("#device-breakpoints").remove();
    $(".after").append(
      "<script>function customToastr(message,type){toastr.options.hideDuration = 0;toastr.clear();" +
      "toastr.options.closeButton = true;toastr.options.progressBar = false;toastr.options.debug = false;" +
      "toastr.options.positionClass = 'toast-top-right';toastr.options.showDuration = 330;toastr.options.hideDuration = 330;" +
      "toastr.options.timeOut = 5000;toastr.options.extendedTimeOut = 1000;toastr.options.showEasing = 'swing';" +
      "toastr.options.hideEasing = 'swing';toastr.options.showMethod = 'slideDown';toastr.options.hideMethod = 'slideUp';" +
      "toastr[type](message, '');return 0;} </" +
      "script>"
    );
  }

  //Displaying Random Quotes
  generateRandomIndex(): void {
    this.currentIndex = Math.floor(Math.random() * this.messages.length);
  }
  //Navigating to the register
  openRegisterLink() {
    const protocol = window.location.protocol;
    const hostName = window.location.hostname;
    if (this.isLocalHost(hostName)) {
      window.location.href = this.loginStrings.localHostLogin;
    } else {
      const domainSuffix = this.brand.domainSuffix || hostName.split(".").slice(1).join(".");
      window.location.href = protocol + "//registration." + domainSuffix;
    }
  }

  //Email address debouncing function
  handleDebounceEmail(value: string): void {
    clearTimeout(this.loginDebounceTimer);
      this.loginDebounceTimer = setTimeout(() => {
        this.loginMode == 'WEB_ADMIN' ? this.triggerLoginEmailError(value) : this.validateUserCredentials();
      }, 800);
  }

  //Email address validation function
  triggerLoginEmailError(input: any) {
    const emailAddress = input.value.trim();
    this.emailAddressLength = emailAddress.length;
    this.userEmail = emailAddress;
    if (this.emailAddressLength < 2 && this.emailAddressLength > 0) {
      this.errorMessage.userEmail =
        this.loginStrings.errorMessageForUserOrEmailAddress;
      this.isEmailAddressValid = false;
    } else {
      this.errorMessage.userEmail = "";
      this.isEmailAddressValid = true;
    }
  }

  // API call for domain exist or not
  async verifySchoolDomainDetails(subDomain: string) {
    try {
      const hostName = window.location.hostname;
      const domainSuffix = this.brand.domainSuffix || hostName.split(".").slice(1).join(".");
      const body = {
        domainName: subDomain,
        lang: "en",
        partnerDomain: domainSuffix,
      };
      const response = await firstValueFrom(
        this.newLoginWithDomainVerificationServices.verifySchoolDomainDetailsApi(
          body
        )
      );
      const responseDetails = response as any;
      if (responseDetails.status) {
        if (responseDetails.body && responseDetails.body.schoolDomainDetails) {
          const schoolDetails = responseDetails.body.schoolDomainDetails[0];
          this.isFranchise = schoolDetails.isFranchise;
          this.fkFranchiseId = schoolDetails.fkFranchiseId;
          this.loginSchoolLogo = schoolDetails.schoolImage;
        }
      } else {
        customToastr(responseDetails.message, this.loginStrings.error);
        if (this.isLocalHost(hostName)) {
          window.location.href = this.loginStrings.localHostLoginUrl;
        } else {
          setTimeout(() => {
            if (this.isLocalHost(hostName)) {
              window.location.href = this.loginStrings.localHostLoginUrl;
            } else {
              window.location.href =
                window.location.protocol + this.prodHostLoginUrl();
            }
          }, 1000);
        }
      }
    } catch (error) {
      const hostName = window.location.hostname;
      if (
        error.error &&
        error.error.status_code &&
        error.error.status_code === 401 &&
        error.error.message === this.loginStrings.schoolSuspendedMessage
      ) {
        alert(error.error.message);
        if (this.isLocalHost(hostName)) {
          window.location.href = this.loginStrings.localHostLoginUrl;
        } else {
          window.location.href =
            window.location.protocol + this.prodHostLoginUrl();
        }
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage')); 
        customToastr(
          error
            ? error.error
              ? error.error.message
              : errorMessageTranslation
            : errorMessageTranslation,
          this.loginStrings.error
        );
        if (this.isLocalHost(hostName)) {
          window.location.href = this.loginStrings.localHostLoginUrl;
        } else {
          setTimeout(() => {
            if (this.isLocalHost(hostName)) {
              window.location.href = this.loginStrings.localHostLoginUrl;
            } else {
              window.location.href =
                window.location.protocol + this.prodHostLoginUrl();
            }
          }, 1000);
        }
      }
    }
  }

  //Api call for School domain login with otp
  async schoolDomainLoginWithOtp() {
    try {
      this.loader = true;
      this.otp = ["", "", "", ""];
      const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
      const body = {
        domainName: this.subDomain,
        userName: this.userEmail,
        lang: "en",
        partnerDomain: domainSuffix,
      };
      const response = await firstValueFrom(
        this.newLoginWithDomainVerificationServices.schoolDomainLoginWithOtpApi(
          body
        )
      );
      const responseDetails = response as any;
      if (responseDetails.status) {
        if (responseDetails.body) {
          this.countdown = responseDetails.body.attemptLeft;
          this.otpVerificationPage = true;
          this.otpTime = 30;
          this.otpTimerCountdown();
          customToastr(responseDetails.body.message, this.loginStrings.success);
        }
      } else {
        customToastr(responseDetails.message, this.loginStrings.error);
      }
      this.loader = false;
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage')); 
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
        this.loginStrings.error
      );
      this.loader = false;
    }
  }

  // Staff login is password-only now — this only handles the admin
  // (non-staff) OTP path.
  getOTPForDomainLogin() {
    if (!this.isStaffLogin) {
      this.schoolDomainLoginWithOtp();
    }
  }

  togglePasswordInput() {
    this.showPasswordInput = !this.showPasswordInput;
  }

  handleOnclickPassword() {
    this.otpVerificationPage = false;
    this.showPasswordInput = true;
  }

  handleForgotPassword() {
    this.userEmail = ''
    this.isForgotPassword = true;
    this.isGoBack = true;
    this.showPasswordInput = false;
    this.otpVerificationPage = false;
  }


  //Password debouncing function
  handleDebouncePassword(value: string): void {
    clearTimeout(this.loginDebounceTimer);
    this.loginDebounceTimer = setTimeout(() => {
      this.triggerLoginPasswordError(value);
    }, 800);
  }

  triggerLoginPasswordError(input: any) {
    const passwordInput = input.value.trim();
    this.passwordLength = passwordInput.length;
    this.password = passwordInput;

  }

  handleDebounceConfirmPassword(value: string): void {
    clearTimeout(this.loginDebounceTimer);
    this.loginDebounceTimer = setTimeout(() => {
      this.triggerConfirmPasswordError(value);
    }, 800);
  }

  triggerConfirmPasswordError(input: any) {
    const confirmNewPasswordInput = input.value.trim();
    this.passwordLength = confirmNewPasswordInput.length;
    this.confirmNewPassword = confirmNewPasswordInput;
  }


  submitPasswordVerification() {
    if(this.loginMode === "WEB_ADMIN" && !this.isStaffLogin){
      this.schoolDomainLoginWithPassword();
    }else{
      const isValid = this.validateUserCredentials();
      if (isValid) {
        this.staffLogin();
      }
    } 
  }

 
  // Accepts either a mobile number (digits only) or an email address —
  // mobileOrEmail is forwarded to the API as-is either way.
  private readonly emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  validateUserCredentials(): boolean {
    this.errorMessage.userEmail = '';
    this.errorMessage.password = '';
    this.passwordInput.control.markAsTouched();
    if ((!this.userEmail || this.userEmail.trim() === '') && this.isStaffLogin ) {
      this.errorMessage.userEmail =  this.loginStrings.emptyMobileNumberOrEmail ;
      return false;
    }
    const trimmedValue = this.userEmail ? this.userEmail.trim() : '';
    if (trimmedValue && !/^\d+$/.test(trimmedValue) && !this.emailPattern.test(trimmedValue)) {
      this.errorMessage.userEmail = this.loginStrings.invalidMobileOrEmail;
      return false;
    }

    if (!this.password || this.password.trim() === '') {
      this.errorMessage.password = this.loginStrings.emptyPassword;
      return false;
    }

    return true;
  }
  
  // Staff password login — hits the same /api/v3 staff server as the OTP
  // flow and returns the same schoolAndStaffDetailData shape, so the
  // resulting session is stored identically to verifyStaffOtpWithMobileNumber
  // (staffDetails in localStorage) and every staff-portal page keeps working.
  async staffLogin(){
    try {
      this.loader = true;
      const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
      const body = {
        mobileOrEmail: this.userEmail,
        password: this.password,
        schoolDomain: this.subDomain,
        partnerDomain: domainSuffix,
      };
      const response = await firstValueFrom(
        this.staffLoginService.loginWithPassword(body)
      );
      const responseDetails = response as any;
      this.loader = false;
      if (responseDetails.status && responseDetails.body && responseDetails.body.schoolAndStaffDetailData && responseDetails.body.schoolAndStaffDetailData.length) {
        this.establishStaffSession(responseDetails.body.schoolAndStaffDetailData[0]);
      } else {
        const invalidStaffCredentialsTranslation = await firstValueFrom(this.translate.get('invalidStaffCredentials'));
        customToastr(
          responseDetails.message || invalidStaffCredentialsTranslation,
          this.loginStrings.error
        );
      }
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
        this.loginStrings.error
      );
      this.loader = false;
    }
  }

  // Shared session-establishment: writes the same cookies/localStorage
  // whether the staffDetail came from password login or QR-code login, so
  // both paths land the user in an identical, working staff session.
  // Returns the navigation promise so callers (QR polling) can keep their
  // own loader up until the route change has actually settled.
  private establishStaffSession(staffDetail: any) {
    localStorage.setItem('staffDetails', JSON.stringify(staffDetail));
    const hostName = window.location.hostname;
    if (this.isLocalHost(hostName)) {
      this.commonFunction.setCookieLocal(this.loginStrings.loginMode, this.loginMode, 7);
      this.commonFunction.setCookieLocal('extensionServices', staffDetail.schoolExtensionServicePermissions ? JSON.stringify(staffDetail.schoolExtensionServicePermissions) : null, 7);
      this.commonFunction.setCookieLocal(this.loginStrings.usertoken, staffDetail.session, 7);
      this.commonFunction.setCookieLocal(this.loginStrings.schoolinfo, staffDetail.schoolId, 7);
      this.commonFunction.setCookieLocal(this.loginStrings.staffName, staffDetail.staffName, 7);
      if (staffDetail.SchoolDomain) {
        this.commonFunction.setCookieLocal(this.loginStrings.schoolDomain, staffDetail.SchoolDomain, 7);
      }
    } else {
      this.commonFunction.setCookie(this.loginStrings.loginMode, this.loginMode, 7);
      this.commonFunction.setCookie('extensionServices', staffDetail.schoolExtensionServicePermissions ? JSON.stringify(staffDetail.schoolExtensionServicePermissions) : null, 7);
      this.commonFunction.setCookie(this.loginStrings.usertoken, staffDetail.session, 7);
      this.commonFunction.setCookie(this.loginStrings.schoolinfo, staffDetail.schoolId, 7);
      this.commonFunction.setCookie(this.loginStrings.staffName, staffDetail.staffName, 7);
      if (staffDetail.SchoolDomain) {
        this.commonFunction.setCookie(this.loginStrings.schoolDomain, staffDetail.SchoolDomain, 7);
      }
    }
    return this.router.navigate(['/staff', STAFF_DEFAULT_SCREEN]);
  }

  //API Call for domain login with password
  async schoolDomainLoginWithPassword() {
    try {
      this.loader = true;
      const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
      const body = {
        domainName: this.subDomain,
        userName: this.userEmail,
        password: this.password,
        lang: "en",
        partnerDomain: domainSuffix,
      };
      const response = await firstValueFrom(
        this.newLoginWithDomainVerificationServices.schoolDomainLoginWithPasswordApi(
          body
        )
      );
      const responseDetails = response as any;
      const hostName = window.location.hostname;
      if (responseDetails.status) {
        if (
          responseDetails.body &&
          responseDetails.body.schoolInfo &&
          responseDetails.body.schoolInfo.isSchoolVerified &&
          responseDetails.body.schoolInfo.token
        ) {
          const schoolInfoDetails = responseDetails.body.schoolInfo.schoolInfo;
          if (responseDetails.body.schoolInfo.schoolInfo) {
            if (this.isLocalHost(hostName)) {
              this.commonFunction.setCookieLocal(this.loginStrings.loginMode, this.loginMode, 7);
              this.commonFunction.setCookieLocal('extensionServices',JSON.stringify(responseDetails.body.schoolInfo.schoolExtensionServicePermissions), 7);
              this.commonFunction.setCookieLocal(this.loginStrings.usertoken, responseDetails.body.schoolInfo.token, 7);
              this.commonFunction.setCookieLocal(this.loginStrings.schoolinfo, schoolInfoDetails.schoolId, 7);
              this.commonFunction.setCookieLocal(this.loginStrings.adminType, schoolInfoDetails.adminType, 7);
              this.commonFunction.setCookieLocal(this.loginStrings.feesModuleSettings, JSON.stringify(schoolInfoDetails.feesModuleSettings), 7);
              this.commonFunction.setCookieLocal(this.loginStrings.currency, schoolInfoDetails.currencyType, 7);
              this.commonFunction.setCookieLocal(this.loginStrings.isFranchise, schoolInfoDetails.isFranchise == 0 ? "0" : schoolInfoDetails.isFranchise, 7);
              this.commonFunction.setCookieLocal(this.loginStrings.fkFranchiseId, schoolInfoDetails.fkFranchiseId ? schoolInfoDetails.fkFranchiseId : "null", 7); const d = {};
              this.commonFunction.setCookieLocal(this.loginStrings.countryCode, schoolInfoDetails.countryCode, 7);
              const arr = schoolInfoDetails.adminPermissions;
              arr.forEach(item => {
                d[item.BluewingsFeatureName] = item.ActiveStatus || item.AdminAccessStatus;
              });
              this.commonFunction.setCookieLocal(this.loginStrings.adminPermissionlist, JSON.stringify(d), 7);
            } else {
              this.commonFunction.setCookie(this.loginStrings.loginMode, this.loginMode, 7);
              this.commonFunction.setCookie(this.loginStrings.usertoken, responseDetails.body.schoolInfo.token, 7);
              this.commonFunction.setCookie(this.loginStrings.schoolinfo, schoolInfoDetails.schoolId, 7);
              this.commonFunction.setCookie(this.loginStrings.adminType, schoolInfoDetails.adminType, 7);
              this.commonFunction.setCookie(this.loginStrings.feesModuleSettings, JSON.stringify(schoolInfoDetails.feesModuleSettings), 7);
              this.commonFunction.setCookie(this.loginStrings.currency, schoolInfoDetails.currencyType, 7);
              this.commonFunction.setCookie(this.loginStrings.isFranchise, schoolInfoDetails.isFranchise == 0 ? "0" : schoolInfoDetails.isFranchise, 7);
              this.commonFunction.setCookie(this.loginStrings.fkFranchiseId, schoolInfoDetails.fkFranchiseId, 7);
              this.commonFunction.setCookie(this.loginStrings.schoolDomain, schoolInfoDetails.SchoolDomain, 7);
              this.commonFunction.setCookie(this.loginStrings.countryCode, schoolInfoDetails.countryCode, 7);
             this.commonFunction.setCookie('extensionServices',responseDetails.body.schoolInfo.schoolExtensionServicePermissions?JSON.stringify(responseDetails.body.schoolInfo.schoolExtensionServicePermissions):null, 7);

              const d = {};
              const arr = schoolInfoDetails.adminPermissions;
              arr.forEach(item => {
                d[item.BluewingsFeatureName] = item.ActiveStatus || item.AdminAccessStatus;
              });
              this.commonFunction.setCookie(this.loginStrings.adminPermissionlist, JSON.stringify(d), 7);

            }
            this.commonFunction.disableBackButton()
            customToastr(responseDetails.body.message, this.loginStrings.success);
            this.commonFunction.syncSessionCookiesToLocalStorage();
            if (schoolInfoDetails.isFranchise == 1) {
              this.router.navigate(["/franchise/dashboard"]);
            } else {
              this.router.navigate(["/dashboard"]);
            }
            this.emailAddressLength = 0;
            this.userEmail = "";
            this.password = "";
            this.passwordLength = 0;
          }
        } else if (responseDetails.body && responseDetails.body.schoolInfo && responseDetails.body.schoolInfo.isStep1Completed) {
          if (this.isLocalHost(hostName)) {
            const subDomain = this.subDomain
            this.commonFunction.setCookieLocal(this.loginStrings.usertoken, responseDetails.body.schoolInfo.token, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolVerification, this.loginStrings.underVerification, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolDomain, responseDetails.body.schoolInfo.schoolDomain, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolDomain, subDomain, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolAddress, responseDetails.body.schoolInfo.step1Data.address, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.phoneNumber, responseDetails.body.schoolInfo.underVerificationData.phoneNumber, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolEmailId, responseDetails.body.schoolInfo.underVerificationData.emailId, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolName, responseDetails.body.schoolInfo.underVerificationData.schoolName, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.countryCode, responseDetails.body.schoolInfo.underVerificationData.countryCode, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolImage, responseDetails.body.schoolInfo.underVerificationData.schoolImage, 7);
          }
          else {
            const subDomain = this.subDomain
            this.commonFunction.setCookie(this.loginStrings.usertoken, responseDetails.body.schoolInfo.token, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolVerification, this.loginStrings.underVerification, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolDomain, responseDetails.body.schoolInfo.schoolDomain, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolDomain, subDomain, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolAddress, responseDetails.body.schoolInfo.step1Data.address, 7);
            this.commonFunction.setCookie(this.loginStrings.phoneNumber, responseDetails.body.schoolInfo.underVerificationData.phoneNumber, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolEmailId, responseDetails.body.schoolInfo.underVerificationData.emailId, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolName, responseDetails.body.schoolInfo.underVerificationData.schoolName, 7);
            this.commonFunction.setCookie(this.loginStrings.countryCode, responseDetails.body.schoolInfo.underVerificationData.countryCode, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolImage, responseDetails.body.schoolInfo.underVerificationData.schoolImage, 7);
          }
          this.commonFunction.disableBackButton()
          customToastr(responseDetails.body.message, this.loginStrings.success);
          this.router.navigate(["/institute-under-verification"]);
        }
        else if (responseDetails.body && responseDetails.body.schoolInfo && responseDetails.body.schoolInfo.isStep1Completed === false) {
          if (this.isLocalHost(hostName)) {
            const subDomain = this.subDomain
            this.commonFunction.setCookieLocal(this.loginStrings.usertoken, responseDetails.body.schoolInfo.token, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolVerification, this.loginStrings.step1, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolDomain, responseDetails.body.schoolInfo.schoolDomain, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolDomain, subDomain, 7);
          }
          else {
            const subDomain = this.subDomain
            this.commonFunction.setCookie(this.loginStrings.usertoken, responseDetails.body.schoolInfo.token, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolVerification, this.loginStrings.step1, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolDomain, responseDetails.body.schoolInfo.schoolDomain, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolDomain, subDomain, 7);
          }
          this.commonFunction.disableBackButton()
          customToastr(responseDetails.body.message, this.loginStrings.success);
          this.router.navigate(["/institute-onboard/step/1"]);
        }
        this.clearInputValues()
      } else {
        customToastr(responseDetails.message, this.loginStrings.error);
      }
      this.loader = false;
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage')); 
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
        this.loginStrings.error
      );
      this.loader = false;
    }
  }


  // Drives the top-mounted Admin Login / Staff Login segmented control.
  // Explicit target mode (rather than a plain toggle) so each option is a
  // direct action, not dependent on the previous state - also fixes a bug
  // where loginMode was hardcoded to 'STAFF' on every switch, including
  // switching back to Admin.
  setLoginMode(mode: 'WEB_ADMIN' | 'STAFF') {
    if (this.loginMode === mode) {
      return;
    }
    this.clearInputValues();
    this.errorMessage.userEmail = "";
    this.isStaffLogin = mode === 'STAFF';
    // Both staff and admin login default to password.
    this.showPasswordInput = true;
    this.loginMode = mode;
    if (this.passwordInput) {
      this.passwordInput.control.setErrors(null);
      this.passwordInput.control.markAsUntouched();
    }
  }

  async verifyingOtpForDomainLogin() {
    try {
      this.loader = true;
      const otpForEmail = this.otp.join("");
      const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
      const body = {
        lang: "en",
        userName: this.userEmail,
        otp: otpForEmail,
        domainName: this.subDomain,
        partnerDomain: domainSuffix,
      };
      const response = await firstValueFrom(
        this.newLoginWithDomainVerificationServices.verifyingOtpForDomainLoginApi(body)
      );
      const responseDetails = response as any;
      const hostName = window.location.hostname;
      if (responseDetails.status) {
        if (
          responseDetails.body &&
          responseDetails.body.schoolInfo &&
          responseDetails.body.schoolInfo.isSchoolVerified &&
          responseDetails.body.schoolInfo.token
        ) {
          const schoolInfoDetails = responseDetails.body.schoolInfo.schoolInfo;
          if (responseDetails.body.schoolInfo.schoolInfo) {
            if (this.isLocalHost(hostName)) {
              this.commonFunction.setCookieLocal(this.loginStrings.loginMode, this.loginStrings.WEB_ADMIN, 7);
              this.commonFunction.setCookieLocal(this.loginStrings.usertoken, responseDetails.body.schoolInfo.token, 7);
              this.commonFunction.setCookieLocal('extensionServices',JSON.stringify(responseDetails.body.schoolInfo.schoolExtensionServicePermissions), 7);
              this.commonFunction.setCookieLocal(this.loginStrings.schoolinfo, schoolInfoDetails.schoolId, 7);
              this.commonFunction.setCookieLocal(this.loginStrings.adminType, schoolInfoDetails.adminType, 7);
              this.commonFunction.setCookieLocal(this.loginStrings.feesModuleSettings, JSON.stringify(schoolInfoDetails.feesModuleSettings), 7);
              this.commonFunction.setCookieLocal(this.loginStrings.currency, schoolInfoDetails.currencyType, 7);
              this.commonFunction.setCookieLocal(this.loginStrings.isFranchise, schoolInfoDetails.isFranchise == 0 ? "0" : schoolInfoDetails.isFranchise, 7);
              this.commonFunction.setCookieLocal(this.loginStrings.fkFranchiseId, schoolInfoDetails.fkFranchiseId, 7);
              this.commonFunction.setCookieLocal(this.loginStrings.schoolDomain, schoolInfoDetails.SchoolDomain, 7);
              this.commonFunction.setCookieLocal(this.loginStrings.countryCode, schoolInfoDetails.countryCode, 7);
              const d = {};
              const arr = schoolInfoDetails.adminPermissions;
              arr.forEach(item => {
                d[item.BluewingsFeatureName] = item.ActiveStatus || item.AdminAccessStatus;
              });
              this.commonFunction.setCookieLocal(this.loginStrings.adminPermissionlist, JSON.stringify(d), 7);

            } else {
              this.commonFunction.setCookie('extensionServices',JSON.stringify(responseDetails.body.schoolInfo.schoolExtensionServicePermissions), 7);
              this.commonFunction.setCookie(this.loginStrings.loginMode, this.loginStrings.WEB_ADMIN, 7);
              this.commonFunction.setCookie(this.loginStrings.usertoken, responseDetails.body.schoolInfo.token, 7);
              this.commonFunction.setCookie(this.loginStrings.schoolinfo, schoolInfoDetails.schoolId, 7);
              this.commonFunction.setCookie(this.loginStrings.adminType, schoolInfoDetails.adminType, 7);
              this.commonFunction.setCookie(this.loginStrings.feesModuleSettings, JSON.stringify(schoolInfoDetails.feesModuleSettings), 7);
              this.commonFunction.setCookie(this.loginStrings.currency, schoolInfoDetails.currencyType, 7);
              this.commonFunction.setCookie(this.loginStrings.isFranchise, schoolInfoDetails.isFranchise == 0 ? "0" : schoolInfoDetails.isFranchise, 7);
              this.commonFunction.setCookie(this.loginStrings.fkFranchiseId, schoolInfoDetails.fkFranchiseId, 7);
              this.commonFunction.setCookie(this.loginStrings.schoolDomain, schoolInfoDetails.SchoolDomain, 7);
              this.commonFunction.setCookie(this.loginStrings.countryCode, schoolInfoDetails.countryCode, 7);
              const d = {};
              const arr = schoolInfoDetails.adminPermissions;
              arr.forEach(item => {
                d[item.BluewingsFeatureName] = item.ActiveStatus || item.AdminAccessStatus;
              });
              this.commonFunction.setCookie(this.loginStrings.adminPermissionlist, JSON.stringify(d), 7);

            }
            this.commonFunction.disableBackButton()
            customToastr(responseDetails.body.message, this.loginStrings.success);
            this.commonFunction.syncSessionCookiesToLocalStorage();
            if (schoolInfoDetails.isFranchise == 1) {
              this.router.navigate(["/franchise/dashboard"]);
            } else {
              this.router.navigate(["/dashboard"]);
            }
            this.emailAddressLength = 0;
            this.userEmail = "";
            this.password = "";
            this.passwordLength = 0;
          }
        } else if (responseDetails.body && responseDetails.body.schoolInfo && responseDetails.body.schoolInfo.isStep1Completed) {
          if (this.isLocalHost(hostName)) {
            const subDomain = this.subDomain
            this.commonFunction.setCookieLocal(this.loginStrings.usertoken, responseDetails.body.schoolInfo.token, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolVerification, this.loginStrings.underVerification, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolDomain, responseDetails.body.schoolInfo.schoolDomain, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolDomain, subDomain, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolAddress, responseDetails.body.schoolInfo.step1Data.address, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.phoneNumber, responseDetails.body.schoolInfo.underVerificationData.phoneNumber, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolEmailId, responseDetails.body.schoolInfo.underVerificationData.emailId, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolName, responseDetails.body.schoolInfo.underVerificationData.schoolName, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.countryCode, responseDetails.body.schoolInfo.underVerificationData.countryCode, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolImage, responseDetails.body.schoolInfo.underVerificationData.schoolImage, 7);
          }
          else {
            const subDomain = this.subDomain
            this.commonFunction.setCookie(this.loginStrings.usertoken, responseDetails.body.schoolInfo.token, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolVerification, this.loginStrings.underVerification, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolDomain, responseDetails.body.schoolInfo.schoolDomain, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolDomain, subDomain, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolAddress, responseDetails.body.schoolInfo.step1Data.address, 7);
            this.commonFunction.setCookie(this.loginStrings.phoneNumber, responseDetails.body.schoolInfo.underVerificationData.phoneNumber, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolEmailId, responseDetails.body.schoolInfo.underVerificationData.emailId, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolName, responseDetails.body.schoolInfo.underVerificationData.schoolName, 7);
            this.commonFunction.setCookie(this.loginStrings.countryCode, responseDetails.body.schoolInfo.underVerificationData.countryCode, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolImage, responseDetails.body.schoolInfo.underVerificationData.schoolImage, 7);
          }
          this.commonFunction.disableBackButton()
          customToastr(responseDetails.body.message, this.loginStrings.success);
          this.router.navigate(["/institute-under-verification"]);
        }
        else if (responseDetails.body && responseDetails.body.schoolInfo && responseDetails.body.schoolInfo.isStep1Completed === false) {
          if (this.isLocalHost(hostName)) {
            const subDomain = this.subDomain
            this.commonFunction.setCookieLocal(this.loginStrings.usertoken, responseDetails.body.schoolInfo.token, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolVerification, this.loginStrings.step1, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolDomain, responseDetails.body.schoolInfo.schoolDomain, 7);
            this.commonFunction.setCookieLocal(this.loginStrings.schoolDomain, subDomain, 7);
          }
          else {
            const subDomain = this.subDomain
            this.commonFunction.setCookie(this.loginStrings.usertoken, responseDetails.body.schoolInfo.token, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolVerification, this.loginStrings.step1, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolDomain, responseDetails.body.schoolInfo.schoolDomain, 7);
            this.commonFunction.setCookie(this.loginStrings.schoolDomain, subDomain, 7);
          }
          this.commonFunction.disableBackButton()
          customToastr(responseDetails.body.message, this.loginStrings.success);
          this.router.navigate(["/institute-onboard/step/1"]);
        }
        this.clearInputValues()
      } else {
        customToastr(responseDetails.message, this.loginStrings.error);
      }
      this.loader = false;
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage')); 
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
        this.loginStrings.error
      );
      this.loader = false;
      return;
    }
  }

  // Staff's forgot-password OTP is 6 digits; admin's is 4.
  private resetForgotPasswordOtpInputs(): void {
    const length = this.isStaffLogin ? 6 : 4;
    this.otpForForgotPassword = new Array(length).fill("");
  }

  clearInputValues() {
    this.userEmail = "";
    this.password = "";
    this.emailAddressLength = 0;
    this.passwordLength = 0;
    this.otp = ["", "", "", ""];
    this.confirmNewPassword = ""
    this.isResetPassword = false;
    this.isForgotPassword = false;
    this.resetForgotPasswordOtpInputs();
    this.isGoBack = false
    this.staffForgotPasswordToken = null;
  }

  moveToNext(event: KeyboardEvent, index: number) {

    const keyPressed = event.key;
    const isNumber = !isNaN(Number(keyPressed));

    // If the key is not a number or backspace, prevent default behavior
    if (!isNumber && event.key !== this.loginStrings.backspace) {
      event.preventDefault();
      return;
    }

    // If the backspace key is pressed and the input field is empty, focus on the previous input field
    if (
      event.key === this.loginStrings.backspace &&
      index > 0 &&
      event.target instanceof HTMLInputElement
    ) {
      const previousInput = document.getElementById(
        "otp-input-" + (index - 1)
      ) as HTMLInputElement;
      if (previousInput) {
        previousInput.focus();
      }
    }

    // If a number key is pressed and the current input field is not the last one, focus on the next input field
    if (isNumber && index < this.otp.length - 1) {
      const nextInput = document.getElementById(
        "otp-input-" + (index + 1)
      ) as HTMLInputElement;
      if (nextInput) {
        nextInput.focus();
      }
    }
    this.otpInputsFilled = this.allOtpInputsFilled();
  }


  moveToNextForForgotPasswordOTP(event: KeyboardEvent, index: number) {

    const keyPressed = event.key;
    const isNumber = !isNaN(Number(keyPressed));

    // If the key is not a number or backspace, prevent default behavior
    if (!isNumber && event.key !== this.loginStrings.backspace) {
      event.preventDefault();
      return;
    }

    // If the backspace key is pressed and the input field is empty, focus on the previous input field
    if (
      event.key === this.loginStrings.backspace &&
      index > 0 &&
      event.target instanceof HTMLInputElement
    ) {
      const previousInput = document.getElementById(
        "send-otp-input-" + (index - 1)
      ) as HTMLInputElement;
      if (previousInput) {
        previousInput.focus();
      }
    }

    // If a number key is pressed and the current input field is not the last one, focus on the next input field
    if (isNumber && index < this.otpForForgotPassword.length - 1) {
      const nextInput = document.getElementById(
        "send-otp-input-" + (index + 1)
      ) as HTMLInputElement;
      if (nextInput) {
        nextInput.focus();
      }
    }
    this.otpInputsFilled = this.OtpInputsFilled();
  }

  OtpInputsFilled(): boolean {
    return this.otpForForgotPassword.every((input) => input.trim() !== "");
  }

  handleKeyDown(event: KeyboardEvent): void {
    const allowedKeys = [
      "ArrowLeft",
      "ArrowRight",
      "Backspace",
      "Delete",
      "Home",
      "End",
    ];
    if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  handleGoBack() {
    if (this.isForgotPassword) {
      this.isForgotPassword = false
      this.otpVerificationPage = false;
      this.showPasswordInput = true;
      this.isGoBack = false;
    } else if (this.isResetPassword) {
      this.isForgotPassword = true
      this.isResetPassword = false;
      this.staffForgotPasswordToken = null;
    }
    this.userEmail = "";
  }
  allOtpInputsFilled(): boolean {
    return this.otp.every((input) => input.trim() !== "");
  }

  trackByIndex(index: number): number {
    return index;
  }


  resendOtp() {
    this.getOTPForDomainLogin();
  }

  otpTimerCountdown() {

    this.otpTime = 30;
    const interval = setInterval(() => {
      if (this.countdown > 0) {
        if (this.otpTime > 0) {
          this.otpTime--;
        } else {
          clearInterval(interval);
        }
      }
    }, 1000);
  }

  // Staff login is password-only now — this only handles the admin
  // (non-staff) OTP verify path.
  handleVerifyDomainOtpLogin() {
    if (!this.isStaffLogin) {
      this.verifyingOtpForDomainLogin();
    }
  }

  checkSession() {
    const tokenCookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.usertoken + this.loginStrings.equalTo));
    let tokenValue = tokenCookie ? tokenCookie.split('=')[1] : null;
    if (tokenValue) {
      const isFranchiseValue = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.isFranchise + this.loginStrings.equalTo));
      let isFranchise = isFranchiseValue ? isFranchiseValue.split('=')[1] : null;
      const schoolVerification = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.schoolVerification + this.loginStrings.equalTo));
      let schoolVerificationValue = schoolVerification ? schoolVerification.split('=')[1] : null;
      if (schoolVerificationValue == this.loginStrings.step1) {
        this.router.navigate(["/institute-onboard/step/1"]);
      } else if (schoolVerificationValue === this.loginStrings.underVerification) {
        this.router.navigate(["/institute-under-verification"]);
      }
      else {
        const loginModeCookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith(this.loginStrings.loginMode + this.loginStrings.equalTo));
        const loginModeValue = loginModeCookie ? loginModeCookie.split('=')[1] : null;
        if (loginModeValue === 'STAFF') {
          this.router.navigate(["/staff", STAFF_DEFAULT_SCREEN]);
        } else if (isFranchise == "1") {
          this.router.navigate(["/franchise/dashboard"]);
        } else {
          this.router.navigate(["/dashboard"]);
        }
      }
    } else {
      this.router.navigate(["/login"]);
    }
  }

  async sendOptForForgotPassword(isResendOtp) {
    if (this.isStaffLogin) {
      return this.sendOtpForStaffForgotPassword(isResendOtp);
    }
    try {
      if (!isResendOtp) {
        this.loader = true;
      }
      const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
      const body = {
        lang: "en",
        email: this.userEmail,
        domain: this.subDomain,
        partnerDomain: domainSuffix,
      };

      const response = await firstValueFrom(
        this.newLoginWithDomainVerificationServices.sendOtpForResetPassword(body)
      );
      const responseDetails = response as any;

      if (responseDetails.status) {
        customToastr(responseDetails.body.message, this.loginStrings.success)
        this.isResetPassword = true
        this.isForgotPassword = false;
        this.otpVerificationPage = false;
        this.showPasswordInput = false;
        this.countdown = responseDetails.body.attemptLeft;
        this.otpTimerCountdown();
      } else {
        customToastr(responseDetails.message, this.loginStrings.error);
      }
      this.loader = false;
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
        this.loginStrings.error
      );
      this.loader = false;
      return;
    }

  }

  // Staff forgot-password OTP send — separate API (generate/otp/for/forgot/
  // password/for/staff) from the admin flow, keyed by schoolDomain+emailId
  // rather than domain+email, but reuses the same isForgotPassword/
  // isResetPassword/otpForForgotPassword UI state.
  private async sendOtpForStaffForgotPassword(isResendOtp: boolean) {
    try {
      if (!isResendOtp) {
        this.loader = true;
      }
      const response = await firstValueFrom(
        this.staffLoginService.generateOtpForForgotPassword(this.subDomain, this.userEmail)
      );
      if (response?.status) {
        const message = response.body?.message || response.message;
        if (message) { customToastr(message, this.loginStrings.success); }
        this.staffForgotPasswordToken = null;
        this.resetForgotPasswordOtpInputs();
        this.isResetPassword = true;
        this.isForgotPassword = false;
        this.otpVerificationPage = false;
        this.showPasswordInput = false;
        this.countdown = response.body?.attemptLeft ?? 3;
        this.otpTimerCountdown();
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
        customToastr(response?.message || errorMessageTranslation, this.loginStrings.error);
      }
      this.loader = false;
    } catch (error: any) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
      customToastr(error?.error?.message || errorMessageTranslation, this.loginStrings.error);
      this.loader = false;
    }
  }

  async resetPassword() {
    if (this.isStaffLogin) {
      return this.resetStaffPassword();
    }
    try {
      const domainSuffix = this.brand.domainSuffix || window.location.hostname.split(".").slice(1).join(".");
      const body = {
        lang: "en",
        email: this.userEmail,
        otp: this.otpForForgotPassword.join(""),
        newPassword: this.password,
        confirmPassword: this.confirmNewPassword,
        partnerDomain: domainSuffix,
      };
      const response = await firstValueFrom(
        this.newLoginWithDomainVerificationServices.resetPassword(body)
      );
      const responseDetails = response as any;
      if (responseDetails.status) {
        this.otpVerificationPage = false;
        this.showPasswordInput = true;
        this.isResetPassword = false;
        this.isGoBack = false;
        customToastr(responseDetails.body.message, this.loginStrings.success)
        this.clearInputValues();
      } else {
        customToastr(responseDetails.message, this.loginStrings.error);
      }
      this.loader = false;
    } catch (error) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
      customToastr(
        error
          ? error.error
            ? error.error.message
            : errorMessageTranslation
          : errorMessageTranslation,
        this.loginStrings.error
      );
      this.loader = false;
      return;
    }
  }

  // Staff reset-password: two separate calls (unlike the admin flow's
  // single OTP+password API) - verify the OTP first to get a one-time
  // token, then use that token (not the OTP) to actually set the password.
  private async resetStaffPassword() {
    try {
      this.loader = true;
      const otp = this.otpForForgotPassword.join("");
      if (!this.staffForgotPasswordToken) {
        const verifyResponse = await firstValueFrom(
          this.staffLoginService.verifyOtpForForgotPassword(this.subDomain, this.userEmail, otp)
        );
        if (!verifyResponse?.status || !verifyResponse.body?.token) {
          const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
          customToastr(verifyResponse?.message || errorMessageTranslation, this.loginStrings.error);
          this.loader = false;
          return;
        }
        this.staffForgotPasswordToken = verifyResponse.body.token;
      }

      const response = await firstValueFrom(
        this.staffLoginService.resetPasswordForStaff(this.subDomain, this.userEmail, this.staffForgotPasswordToken, this.password)
      );
      if (response?.status) {
        this.otpVerificationPage = false;
        this.showPasswordInput = true;
        this.isResetPassword = false;
        this.isGoBack = false;
        this.staffForgotPasswordToken = null;
        const message = response.body?.message || response.message;
        const passwordUpdatedTranslation = await firstValueFrom(this.translate.get('passwordUpdatedSuccessfully'));
        customToastr(message || passwordUpdatedTranslation, this.loginStrings.success);
        this.clearInputValues();
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
        customToastr(response?.message || errorMessageTranslation, this.loginStrings.error);
      }
      this.loader = false;
    } catch (error: any) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
      customToastr(error?.error?.message || errorMessageTranslation, this.loginStrings.error);
      this.loader = false;
    }
  }

  changePasswordType(){
    this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
  }

  // Staff-only QR login: generates a one-time code + PNG image (as a raw
  // Buffer, per the API's own JSON shape) that the mobile app scans to
  // approve this session. Only the generate/display step is implemented
  // here — the scan-approval polling flow lands in a separate change.
  showQrCodeModal: boolean = false;
  qrCodeLoading: boolean = false;
  qrCodeImageUrl: string | null = null;
  qrCode: string | null = null;
  qrCodeExpired: boolean = false;
  // True the instant the poll detects the QR was scanned/approved, until
  // establishStaffSession() navigates away — keeps a loader on screen
  // instead of the modal closing into a blank flash before the route
  // change lands.
  qrCodeSignInLoading: boolean = false;

  private readonly qrCodeDurationSeconds = 5 * 60;
  private readonly qrCodePollIntervalMs = 3000;
  qrCodeSecondsLeft: number = this.qrCodeDurationSeconds;
  private qrCodeTimerHandle: any = null;
  private qrCodePollHandle: any = null;
  private qrCodePollInFlight: boolean = false;

  get qrCodeTimerDisplay(): string {
    const minutes = Math.floor(this.qrCodeSecondsLeft / 60);
    const seconds = this.qrCodeSecondsLeft % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  }

  async openQrCodeLogin() {
    this.showQrCodeModal = true;
    this.qrCodeImageUrl = null;
    this.qrCode = null;
    this.qrCodeExpired = false;
    this.qrCodeLoading = true;
    this.stopQrCodeTimer();
    try {
      const response = await firstValueFrom(this.staffLoginService.generateQrCodeForStaffLogin(this.subDomain));
      if (response?.status && response.body?.qrCodeImage?.data) {
        const bytes = new Uint8Array(response.body.qrCodeImage.data);
        const binary = bytes.reduce((acc, byte) => acc + String.fromCharCode(byte), '');
        this.qrCodeImageUrl = 'data:image/png;base64,' + btoa(binary);
        this.qrCode = response.body.code;
        this.startQrCodeTimer();
        this.startQrCodePolling();
      } else {
        const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
        customToastr(errorMessageTranslation, this.loginStrings.error);
        this.showQrCodeModal = false;
      }
    } catch (error: any) {
      const errorMessageTranslation = await firstValueFrom(this.translate.get('errorMessage'));
      customToastr(error?.error?.message || errorMessageTranslation, this.loginStrings.error);
      this.showQrCodeModal = false;
    } finally {
      this.qrCodeLoading = false;
    }
  }

  private startQrCodeTimer() {
    this.qrCodeSecondsLeft = this.qrCodeDurationSeconds;
    this.qrCodeTimerHandle = setInterval(() => {
      this.qrCodeSecondsLeft--;
      if (this.qrCodeSecondsLeft <= 0) {
        this.qrCodeSecondsLeft = 0;
        this.qrCodeExpired = true;
        this.stopQrCodeTimer();
        this.stopQrCodePolling();
      }
    }, 1000);
  }

  private stopQrCodeTimer() {
    if (this.qrCodeTimerHandle) {
      clearInterval(this.qrCodeTimerHandle);
      this.qrCodeTimerHandle = null;
    }
  }

  // Polls login/staff/with/qr/code/for/web every 3s once a code is showing
  // — a plain interval rather than a recursive setTimeout-after-response
  // chain, guarded by qrCodePollInFlight so a slow response never overlaps
  // with the next tick. Any non-success response (not yet scanned, or a
  // network hiccup) is treated as "still waiting" and polling continues;
  // only a confirmed-successful login or the 5-minute expiry stops it.
  private startQrCodePolling() {
    this.qrCodePollHandle = setInterval(() => this.pollQrCodeLogin(), this.qrCodePollIntervalMs);
  }

  private stopQrCodePolling() {
    if (this.qrCodePollHandle) {
      clearInterval(this.qrCodePollHandle);
      this.qrCodePollHandle = null;
    }
    this.qrCodePollInFlight = false;
  }

  private async pollQrCodeLogin() {
    if (this.qrCodePollInFlight || !this.qrCode || this.qrCodeExpired) { return; }
    this.qrCodePollInFlight = true;
    try {
      const response = await firstValueFrom(this.staffLoginService.loginStaffWithQrCode(this.qrCode, this.subDomain));
      if (response?.status && response.body?.schoolAndStaffDetailData?.length) {
        this.stopQrCodeTimer();
        this.stopQrCodePolling();
        this.qrCodeSignInLoading = true;
        // Keep the loader up for the whole navigation, not just until the
        // call is fired — only close the modal once the route change has
        // actually settled (or fell back to closing on failure, so the
        // user is never stuck behind the loader).
        try {
          await this.establishStaffSession(response.body.schoolAndStaffDetailData[0]);
        } finally {
          this.closeQrCodeLogin();
        }
        return;
      }
      // status:false (not yet scanned/approved) — keep polling silently.
    } catch {
      // Transient/network error while polling — keep trying on the next
      // tick rather than surfacing an error for every missed poll.
    } finally {
      this.qrCodePollInFlight = false;
    }
  }

  refreshQrCodeLogin() {
    this.stopQrCodePolling();
    this.openQrCodeLogin();
  }

  closeQrCodeLogin() {
    this.showQrCodeModal = false;
    this.qrCodeImageUrl = null;
    this.qrCode = null;
    this.qrCodeSignInLoading = false;
    this.stopQrCodeTimer();
    this.stopQrCodePolling();
  }

}
